/*
 * All custom JS to go here
 */
(function initCustomTswWhenReady() {
var $ = window.jQuery || window.$;

if (!$) {
  if (document.readyState !== "complete") {
    document.addEventListener("DOMContentLoaded", initCustomTswWhenReady, { once: true });
    window.addEventListener("load", initCustomTswWhenReady, { once: true });
  }
  return;
}

if (window.__lpCustomTswInitialized) return;
window.__lpCustomTswInitialized = true;

/*
 * For opening size and color selection on product card
 *
 */
var tswMethods = {
  quickShow: function (item) {
    var product = $(item).closest(".product-item");
    var currentSize = $(item).attr("title");

    if (currentSize) {
      //console.log(currentSize);

      var $selectedSizeWrapper = $(product).find(
        '.selector-wrapper-2 [data-value="' + currentSize.trim() + '"]'
      );
      // console.log($selectedSizeWrapper);
      window.setTimeout(function () {
        $($selectedSizeWrapper).find(".single-option").prop("checked", true);
      });
    }
  },

  hidePreviewImages: function (excludeColor) {
    var foundMatch = false;
    var productIsSlide = false;
    var $productNav = $(".productView-nav");
    var productNavSlick = $productNav.data("slick");

    if (
      $productNav.hasClass("slick-initialized") &&
      productNavSlick &&
      productNavSlick.$slides &&
      productNavSlick.$slides.length &&
      productNavSlick.$slideTrack
    ) {
      productIsSlide = true;
    }

    if (productIsSlide) {
      // console.log("product gallery is slider");

      var $selectedColorElm = $(`.productView-image.filter-` + excludeColor);
      //console.log("number of slides :: ", $selectedColorElm.length);

      if ($selectedColorElm.length) {
        var slideIndex = $($selectedColorElm[0]).data("slick-index");
        // console.log("Slide index is: ", slideIndex);
        if (
          typeof slideIndex !== "undefined" &&
          slideIndex >= 0 &&
          slideIndex < productNavSlick.$slides.length
        ) {
          $productNav.slick("slickGoTo", slideIndex);
        }
      }
    } else {
      $(".productView-image-wrapper .productView-image").each(function () {
        let hasClass = `filter-${excludeColor}`;
        if ($(this).hasClass(hasClass)) {
          $(this).removeClass("hide-preview-image");
          foundMatch = true;
        } else {
          $(this).addClass("hide-preview-image");
        }
      });
    }

    if (!foundMatch) {
      // console.log("Did not found any match, remove hide-preview-image");
      $(".productView-image-wrapper .productView-image").removeClass(
        "hide-preview-image"
      );
    }
  },
};

$(document).on("click", ".wrapper-item-size .size-item a", function (e) {
  // console.log("swatch selection script loaded.. ");
  e.preventDefault();

  tswMethods.quickShow(this);
});

$(document).on("click", ".swatch-label", function (e) {
  e.preventDefault();
  // console.log("Swatch clicked");
  var variantId = $(this).data("variant-id");
  var variantImage = $(this).data("variant-img");
  // console.log("Variant ID:", variantId);
  // console.log("Variant Image:", variantImage);
  var productCard = $(this).closest(".product-item");
  // console.log("Product Card:", productCard);

  if (variantImage) {
    var mainImg = productCard.find(".card-media img").first();
    // console.log("Main Image Element:", mainImg);

    if (mainImg.length) {
      mainImg.attr("src", variantImage);
      mainImg.attr("srcset", variantImage);
      mainImg.removeAttr("data-primary-src"); // Clear any data-primary-src attribute
      // console.log("Image updated to:", variantImage);
    } else {
      // console.log("Image element not found");
    }
  }
});

$(document).ready(function () {
  // Ensure secondary image swap on hover works
  $(".product-item").on(
    "mouseenter",
    ".card-media.media--hover-effect",
    function () {
      var primaryImage = $(this).find("img").first();
      var secondaryImage = $(this).find("img").eq(1);

      if (secondaryImage.length > 0) {
        primaryImage.attr("data-primary-src", primaryImage.attr("src"));
        primaryImage.attr("src", secondaryImage.attr("src"));
      }
    }
  );

  $(".product-item").on(
    "mouseleave",
    ".card-media.media--hover-effect",
    function () {
      var primaryImage = $(this).find("img").first();

      if (primaryImage.attr("data-primary-src")) {
        primaryImage.attr("src", primaryImage.attr("data-primary-src"));
        primaryImage.removeAttr("data-primary-src");
      }
    }
  );
});

$(document).ready(function () {
  // Update custom initials stuff
  // TSW Custom Initials
  if (window.Shopify && typeof Shopify.getCart === "function" && window.$halo && typeof window.$halo.tsw_updateCustomInitials === "function") {
    Shopify.getCart((cart) => {
      window.$halo.tsw_updateCustomInitials(cart);
      //console.log("Initing");
    });
  }

  /* Sticky sidebar js */
  var stickyFilter = function () {
    if ($("#main-collection-filters").length) {
      var fromTop = $(window).scrollTop();
      var filterTop = $("#main-collection-filters").parent().offset().top;

      var containerHeight = $("#main-collection-filters").height();

      if (filterTop > fromTop) {
        $("#main-collection-filters").removeClass("sticky-filter");
      } else {
        $("#main-collection-filters").addClass("sticky-filter");
      }
    }
  };

  //
  $(window).on("scroll", function () {
    stickyFilter();
  });

  /*
   * Show only selected product color images
   */
  // On change of product option

  var productFormOption1 = $('.product-form__input[data-option-index="1"]');
  var selectedColor = "";

  if (productFormOption1.length) {
    $("body").on(
      "change",
      '.product-form__input[data-option-index="1"] .product-form__radio',
      function () {
        selectedColor = $(
          '.product-form__input[data-option-index="1"] .product-form__radio:checked'
        ).data("option");
        //console.log("Product selected color change: ", selectedColor);
        tswMethods.hidePreviewImages(selectedColor);
      }
    );

    selectedColor = $(
      '.product-form__input[data-option-index="1"] .product-form__radio:checked'
    ).data("option");

    $(".productView-nav").on("init", function (slider) {
      // console.log("Initialized slick", selectedColor);
      window.setTimeout(function () {
        tswMethods.hidePreviewImages(selectedColor);
      }, 500);
    });
  }

  if (!productFormOption1.length) {
    // console.log("Is single option product.");
    $("body").on(
      "change",
      '.product-form__input .product-form__radio[name="Color"]',
      function () {
        selectedColor = $(
          '.product-form__input .product-form__radio[name="Color"]:checked'
        ).data("option");
        // console.log("Product selected color change: ", selectedColor);
        tswMethods.hidePreviewImages(selectedColor);
      }
    );

    selectedColor = $(
      '.product-form__input .product-form__radio[name="Color"]:checked'
    ).data("option");

    $(".productView-nav").on("init", function (slider) {
      // console.log("Initialized slick 2");
      window.setTimeout(function () {
        tswMethods.hidePreviewImages(selectedColor);
      }, 500);
    });
  }

  tswMethods.hidePreviewImages(selectedColor);

  function hidePreviewImages(selectedColor) {
    $(".productView-image").hide();
    $(".productView-image.filter-" + selectedColor).show();
  }

  /*
   * Removal of products based on custom initials
   */

  $("body").on("click", "[data-cart-remove]", function () {
    var $body = $("body");

    $removeBtn = null;

    // Cart RelatedId
    var related_id = $(this).data("cart-remove-id");
    // console.log("deleted item related id : ", related_id);

    // Now find the Custom Initial product
    if ($body.hasClass("template-cart")) {
      /*
    		$('.cart-list .is-monogram-product').each(function(){
    			var defRelatedId = parseInt( $( this ).find('.product-option.RelatedId .definitionList-value').text().trim() );
    			console.log('Found related Custom Initial ', defRelatedId);

    			if ( defRelatedId == related_id ) {
    				$( this ).find('[data-cart-remove]').trigger('click');
    			}
    		});
        */
    } else {
      // sidebar cart
      /*
    		$('.halo-sidebar-wrapper .previewCartList .is-monogram-product').each(function(){
    			var defRelatedId = parseInt( $( this ).find('.product-option.RelatedId .definitionList-value').text().trim() );
    			console.log('Found related Custom Initial ', defRelatedId);

    			if ( defRelatedId == related_id ) {
    				$( this ).find('[data-cart-remove]').trigger('click');
    			}
    		});
        */
    }
  });

  // disable monogram copy paste
  $(document).ready(function () {
    $("input.disablecopypaste").bind("copy paste", function (e) {
      e.preventDefault();
    });
  });

  $(function () {
    // console.log("disable characters in monogram field");
    $("#monogram").keydown(function (e) {
      if (e.shiftKey || e.ctrlKey || e.altKey) {
        e.preventDefault();
      } else {
        var key = e.keyCode;
        if (
          !(
            key == 8 ||
            key == 32 ||
            key == 46 ||
            (key >= 48 && key <= 57) ||
            (key >= 35 && key <= 40) ||
            (key >= 65 && key <= 90)
          )
        ) {
          //  console.log("Key code is : " + e.keyCode);
          e.preventDefault();
        }
      }
    });

    var ranges = [
      "\ud83c[\udf00-\udfff]", // U+1F300 to U+1F3FF
      "\ud83d[\udc00-\ude4f]", // U+1F400 to U+1F64F
      "\ud83d[\ude80-\udeff]", // U+1F680 to U+1F6FF
    ];
    var matchLetters = /^[A-Za-z0-9]+$/;
    var errorInlineTimer;

    var personalizedShowError = function (errMsg, show = true) {
      var $errBox = $(".personalized-container .input-error-box");

      if (show == true) {
        $errBox.text(errMsg).slideDown();
        errorInlineTimer = setTimeout(function () {
          $errBox.slideUp();
        }, 5000);
      } else {
        $errBox.slideUp();
      }
    };

    var sanitzeInput = function (currVal) {
      //  console.log("current value length is : ", currVal.length);

      var errorMessage = "";
      if (currVal.length > 3) {
        currVal = "";
        errorMessage =
          "Only 2 letters allowed, no special characters or emojis.";
      }

      // Sanitize input
      var sanitizedVal = currVal.replace(new RegExp(ranges.join("|"), "g"), "");
      if (sanitizedVal.match(matchLetters) == null) {
        // Null-guard: #monogram element is only present on personalization-enabled
        // PDPs. Both branches set identical messages anyway, so simplify.
        errorMessage =
          "Only 2 letters allowed, no special characters or emojis.";
        sanitizedVal = "";
      }

      if (errorMessage) {
        personalizedShowError(errorMessage);
      }

      return sanitizedVal;
    };

    $(".slider-single").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      adaptiveHeight: true,
      infinite: false,
      useTransform: true,
      speed: 400,
      cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
    });

    $(".slider-nav").on("init", function (event, slick) {
      slick.$slides.each(function (i) {
        $(this).addClass("slide-" + i);
      });
    });

    $(".slider-nav")
      .on("init", function (event, slick) {
        $(".slider-nav .slick-slide.slick-current").addClass("is-active");
      })
      .slick({
        slidesToShow: 7,
        slidesToScroll: 7,
        dots: false,
        focusOnSelect: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
            },
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
        ],
      });

    $(".slider-single").on(
      "afterChange",
      function (event, slick, currentSlide) {
        $(".slider-nav").slick("slickGoTo", currentSlide);
        var currrentNavSlideElem =
          '.slider-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
        $(".slider-nav .slick-slide.is-active").removeClass("is-active");
        $(currrentNavSlideElem).addClass("is-active");
      }
    );

    $(".slider-nav").on("click", ".slick-slide", function (event) {
      event.preventDefault();
      var goToSingleSlide = $(this).data("slick-index");

      $(".slider-single").slick("slickGoTo", goToSingleSlide);
    });

    $("body").on("change keyup", "#monogram", function (e) {
      // console.log($(this).val());
      var sanitizedVal = sanitzeInput($(this).val());
      $(this).val(sanitizedVal);
    });
  });
});

// document.addEventListener('DOMContentLoaded', function() {
//     // Event listener for trouser length change
//     var trouserLengthInput = document.getElementById('trouser-length');
//     var hiddenInseamLengthInput = document.getElementById('hidden-inseam-length');
//     var addToCartButton = document.getElementById('product-add-to-cart');

//     if (trouserLengthInput && hiddenInseamLengthInput) {
//         trouserLengthInput.addEventListener('change', function() {
//             var selectedLength = this.value;
//             hiddenInseamLengthInput.value = selectedLength;
//         });
//     }

//     // Event listener for the Add to Cart button
//     if (addToCartButton) {
//         addToCartButton.addEventListener('click', function(event) {
//             event.preventDefault();  // Prevent the default form submission
//             addProductToCart();
//         });
//     }

//     function addProductToCart() {
//         // Get the selected trouser length
//         var trouserLength = trouserLengthInput.value;
//         if (!trouserLength || trouserLength.trim() === "") {
//             return;
//         }

//         // Determine the current variant ID
//         var currentVariant;
//         var urlSearchParams = new URLSearchParams(window.location.search);
//         var params = Object.fromEntries(urlSearchParams.entries());
//         if (params.variant) {
//             currentVariant = parseInt(params.variant);
//         } else {
//             currentVariant = currentProduct.variants[0].id;
//         }

//         // Add the product to the cart with the inseam length property
//         var product = {
//             quantity: 1,
//             id: currentVariant,
//             properties: {
//                 'Inseam Length': trouserLength
//             }
//         };

//         fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ "items": [product] })
//         })
//         .then(response => response.json())
//         .then(data => {
//             console.log('Product added to cart:', data);
//             // Optionally, you can trigger an event to update the cart UI here
//             document.querySelector('.header__icon--cart').click();
//             if (typeof $halo !== 'undefined' && $halo.initSidebarCart) {
//                 $halo.initSidebarCart();
//             }
//         })
//         .catch(error => {
//             console.error('Error adding product to cart:', error);
//         });
//     }
// });
window.addEventListener("load", function () {
  // Initialize Splide for the first hero carousel
  var splideHero;
  if (document.querySelector(".hero__carousel__slide__new")) {
    splideHero = new Splide(".hero__carousel__slide__new", {
      type: "loop",
      perPage: 3,
      lazyLoad: "nearby",
      arrows: false,
      pagination: false,
      autoWidth: true,
      gap: 4,
      autoScroll: { speed: 1 },
      breakpoints: {
        1200: { perPage: 2 },
        600: {
          perPage: 1,
          gap: 0,
          autoplay: true,
          interval: 1500,
          speed: 600,
          easing: "ease-in-out",
          autoScroll: false,
          autoWidth: false,
          arrows: false,
        },
      },
    }).mount(window.splide.Extensions);
  }

  // Initialize Splide for the second hero carousel
  var splideHero2;
  if (document.querySelector(".hero__carousel__slide__new__2")) {
    splideHero2 = new Splide(".hero__carousel__slide__new__2", {
      type: "loop",
      perPage: 3,
      lazyLoad: "nearby",
      arrows: false,
      pagination: false,
      autoWidth: true,
      gap: 4,
      autoScroll: { speed: 1 },
      breakpoints: {
        1200: { perPage: 2 },
        600: {
          perPage: 1,
          gap: 0,
          autoplay: true,
          interval: 1500,
          speed: 600,
          easing: "ease-in-out",
          autoScroll: false,
          autoWidth: false,
          arrows: false,
        },
      },
    }).mount(window.splide.Extensions);
  }

  // Listen for window resize and reinitialize all Splide carousels
  window.addEventListener("resize", function () {
    // Destroy and remount the first hero carousel
    if (splideHero) {
      splideHero.destroy().mount(window.splide.Extensions);
    }

    // Destroy and remount the second hero carousel
    if (splideHero2) {
      splideHero2.destroy().mount(window.splide.Extensions);
    }

    // Destroy and remount the collection carousel
    // NOTE: splideCollection is initialized in a separate section/template and may not exist
    // on every page. Use `typeof` to avoid a ReferenceError when it's undeclared.
    if (typeof splideCollection !== "undefined" && splideCollection) {
      try {
        splideCollection.destroy().mount(window.splide.Extensions);
      } catch (e) {
        console.warn("splideCollection remount failed:", e);
      }
    }
  });
});

// Slick carousel initialization for hero__carousel__slide
$(document).ready(function () {
  $(".hero__carousel__slide").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    arrows: false,
    dots: false,
    draggable: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          speed: 5000,
          cssEase: "linear",
          autoplaySpeed: 0,
          arrows: true,
          draggable: true,
        },
      },
    ],
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const splideEl = document.querySelector(".collection__header__carousel");
  let splideInstance = null;

  // Bail early if the collection header carousel isn't on this page
  // (search results, PDPs, cart, etc.). Without this guard, mountSplide()
  // calls splideEl.querySelectorAll(...) on null and throws — that was the
  // "Cannot read properties of null (reading 'querySelectorAll')" error
  // visible in the dev preview log after the splideCollection fix.
  if (!splideEl) {
    return;
  }

  function resetSplideDOM() {
    splideEl.classList.remove(
      "is-initialized",
      "is-active",
      "is-overflow",
      "is-rendered"
    );
    splideEl.removeAttribute("id");

    const list = splideEl.querySelector(".splide__list");
    const track = splideEl.querySelector(".splide__track");
    const clones = splideEl.querySelectorAll(".splide__slide--clone");

    if (list) list.removeAttribute("style");
    if (track) track.removeAttribute("style");

    splideEl.querySelectorAll(".splide__slide").forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("is-active", "is-visible", "is-prev", "is-next");
    });

    clones.forEach((clone) => clone.remove());
  }

  function mountSplide() {
    const totalSlides = splideEl.querySelectorAll(".splide__slide").length;
    const shouldLoop = totalSlides > 4; // Adjust this threshold if needed

    splideInstance = new Splide(splideEl, {
      type: shouldLoop ? "loop" : "slide",
      autoWidth: true,
      rewind: true,
      arrows: false,
      pagination: true,
      gap: "4px",
      speed: 600,
      easing: "ease-out",

      autoplay: true,
      interval: 3000,
      pauseOnHover: true,
      pauseOnFocus: false,
    });

    splideInstance.mount();
  }

  if (!splideInstance) {
    mountSplide();
  }
});
})();
